import React, {useState} from 'react';
import {Button, Form, Input} from "antd";
import useBackendUsers from "../../../../../../../providers/mortgage/useBackendUsers";
import useMortgage from "../../../../../../../providers/mortgage/useMortgage";
import {DeleteOutlined, LoadingOutlined} from "@ant-design/icons";

function AskForMoreUploads({section}) {

    const [state, setState] = useState({busy: false})
    const [anotherUploadForm] = Form.useForm()
    const {me} = useBackendUsers()
    const mortgage = useMortgage()
    const handleFinish = async (values) => {

        setState(s => ({...s, busy: true}))
        const update = {
            target: `progress[${section.progress.id}]`,
            pairs: {
                alertAuthor: me.sub,
                alertBody: values.alertBody.split('\n'),
                alertTitle: values.alertTitle,
                alertDismissed: false
            }
        }
        await mortgage.mutate({update})

        setState(s => ({...s, busy: false}))
    }
    const handleReset = async () => {
        const update = {
            target: `progress[${section.progress.id}]`,
            pairs: {
                alertBody: null,
                alertTitle: null
            }
        }
        await mortgage.mutate({update})
    }
    return (
        <div className="">
            Ask for more uploads for this section
            <Form
                form={anotherUploadForm}
                layout="vertical"
                onFinish={handleFinish}
                initialValues={{
                    alertBody: !!section.progress?.alertBody ? section.progress.alertBody.join('\n') : '',
                    alertTitle: section.progress?.alertTitle || `We need another ${section.title}`,
                }}
            >
                <Form.Item
                    name="alertTitle"
                    label="Title"
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    name="alertBody"
                    label="Description"
                >
                    <Input.TextArea/>
                </Form.Item>
                <div className="d-row gap-3">

                    <Button htmlType="reset" onClick={handleReset}><DeleteOutlined/></Button>
                    <Button htmlType="submit">Save {state.busy && <LoadingOutlined/>}</Button>
                </div>

            </Form>
        </div>
    )

}

export default AskForMoreUploads;